import { API_PATHS } from "./apiPaths";
import { axiosInstance } from "./axiosSetup";

export async function getReferenceAnalysisReports(selectedJournalIds, truncate = true) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      journal_ids: selectedJournalIds.join(','),
      truncate: truncate.toString()
    },
    path: API_PATHS.REFERENCE_ANALYSIS_REPORTS,
    method: "get",
  });
}

export async function getReferenceAnalysisReportByPersistentId(persistentId) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      persistent_id: persistentId
    },
    path: API_PATHS.REFERENCE_ANALYSIS_REPORTS,
    method: "get",
  });
}
